module.exports = __webpack_public_path__ + "images/dbedd37.jpg";